/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Sec_DiscussionInputs */

const en_funnel_demo_sec_discussion = /** @type {(inputs: Funnel_Demo_Sec_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion`)
};

const es_funnel_demo_sec_discussion = /** @type {(inputs: Funnel_Demo_Sec_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discusión`)
};

/**
* | output |
* | --- |
* | "Discussion" |
*
* @param {Funnel_Demo_Sec_DiscussionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_sec_discussion = /** @type {((inputs?: Funnel_Demo_Sec_DiscussionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Sec_DiscussionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_sec_discussion(inputs)
	return en_funnel_demo_sec_discussion(inputs)
});